import React from "react";

function KeysWindow({ handleButton }) {
  const sciKeys = ["sin", "cos", "ln", "log", "tan", "π", "e", "^", "!", "√"];

  const basicKeys = [
    "AC",
    "(",
    ")",
    "/",
    "7",
    "8",
    "9",
    "*",
    "4",
    "5",
    "6",
    "-",
    "1",
    "2",
    "3",
    "+",
    "DEL",
    "0",
    ".",
    "Ans",
  ];

  return (
    <div className="keysWindow">
      <div className="keys_scientific">
        {sciKeys.map((item, index) => (
          <div className="key" key={index} onClick={() => handleButton(item)}>
            {item}
          </div>
        ))}
      </div>

      {/* <div className="line"></div> */}

      <div className="keys_basic">
        {basicKeys.map((item, index) => (
          <div
            key={index}
            className={`key ${item >= "0" && item <= "9" ? "number" : ""} ${
              item === "AC" || item === "DEL" ? "equal" : ""
            }`}
            onClick={() => handleButton(item)}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}

export default KeysWindow;
